<app-language-switch></app-language-switch>

<app-messe-ui [config]="messeConfig"></app-messe-ui>

<app-eaiws-kloeber-layout *ngIf="!showFormular" [optionsInput]="options"></app-eaiws-kloeber-layout>

<div *ngIf="showFormular" class="formular">
    <app-form-kloeber [options]="options"></app-form-kloeber>
</div>